export default __webpack_public_path__ + "static/media/a3.f54f1be5.webp";